"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const articleRestrictedContentInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Article 1",
  },
  {
    name: "subtitle",
    type: "richText",
    required: true,
    defaultValue: "Article 1 subtitle",
  },
  {
    name: "creationDate",
    type: "date",
    required: true,
    helperText: "The creation date of the blog post",
    defaultValue: "2021-08-05T00:00:00.000Z",
  },
  {
    name: "articleId",
    type: "string",
    required: true,
    helperText: "Id corresponding to the id of article set in Open Loyalty",
  },
  {
    name: "image",
    type: "object",
    required: true,
    defaultValue: {
      smallReference:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Ff705e82e3ca347cfba04e0cbd64a00df",
      mediumReference:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Ff705e82e3ca347cfba04e0cbd64a00df",
      largeReference:
        "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Ff705e82e3ca347cfba04e0cbd64a00df",
      altText: "article",
    },
    subFields: [
      {
        name: "smallReference",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
        helperText: "Small version of the image",
        defaultValue: "",
      },
      {
        name: "mediumReference",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
        helperText: "Medium version of the image",
      },
      {
        name: "largeReference",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
        helperText: "Large version of the image",
      },
      {
        name: "altText",
        type: "string",
        required: true,
        helperText: "Alternative text for the image",
      },
    ],
  },
  {
    name: "primaryBtnUrl",
    type: "url",
    required: true,
    defaultValue: "#",
    friendlyName: "The URL of the primary button",
  },
  {
    name: "secondaryBtnUrl",
    type: "url",
    required: true,
    defaultValue: "#",
    friendlyName: "The URL of the secondary button",
  },
  {
    name: "primaryBtnUrlRestricted",
    type: "url",
    required: true,
    defaultValue: "#",
    friendlyName: "The URL of the primary button when restricted by tier",
  },
  {
    name: "previewContent",
    type: "richText",
    required: true,
    defaultValue: "#",
    friendlyName: "Preview content for restricted users",
  },
] as const satisfies Inputs;

export const ArticleRestrictedContentComponent: RegisteredComponent = {
  name: "ArticleRestrictedContent",
  component: dynamic(async () =>
    withValidation(
      articleRestrictedContentInputs,
      (await import("./ArticleRestrictedContent")).ArticleRestrictedContent,
      "ArticleRestrictedContent"
    )
  ),
  canHaveChildren: true,
  inputs: articleRestrictedContentInputs,
};
